require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/node_modules/jquery-slimscroll/jquery.slimscroll.js"))


//////////////////
// WEBPACK FOOTER
// /app/~/script-loader!/app/~/jquery-slimscroll/jquery.slimscroll.js
// module id = ../../../../script-loader/index.js!../../../../jquery-slimscroll/jquery.slimscroll.js
// module chunks = 14